// ======================================================================
// File Name       : participant
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const STORE_PARTICIPANT_LIST = 'STORE_PARTICIPANT_LIST';
export const STORE_PARTICIPANT_DETAIL = 'STORE_PARTICIPANT_DETAIL';
export const STORE_PARTICIPANT_DETAIL_STATUS = 'STORE_PARTICIPANT_DETAIL_STATUS';
// #7129 START
export const RESET_PARTICIPANT_DETAIL = 'RESET_PARTICIPANT_DETAIL';
// #7129 END
